module.exports = __webpack_public_path__ + "assets/img/logitech-astrogaming-w720.aeb864d6.jpg";